export default __webpack_public_path__ + "static/media/normal.f986d46f.png";